module.exports = __webpack_public_path__ + "static/media/peter-pan.363b904a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/peter-pan.png
// module id = 166
// module chunks = 0